<div class="container-device-form" fusePerfectScrollbar>
    <div class="container">
        <div *ngIf="data.deviceList.length!=0" fxLayout="column">
            <div *ngFor="let item of data.deviceList">
                <div style="display: flex; margin: 10px;" fxFlex="100">
                    <p>{{item.id}}</p>
                </div>
                <div style="display: flex; align-items: center; margin: 10px;" fxFlex="100">
                    <button mat-raised-button (click)="change(item)">
                        <span>{{'CHOOSE'|translate}}</span>
                    </button>
                </div>
            </div>
        </div>

        <div *ngIf="data.deviceList.length==0">
            <h3>{{'NO_RECORDS_FOUND'|translate}}</h3>
        </div>
    </div>
</div>